export default (state = [], action) => {
  switch (action.type) {
    case 'REQUEST_TIPS_MODERATION':
      return {
        ...state,
        failureFetching: false,
        isFetching: true,
      };
    case 'REQUEST_TIPS_MODERATION_BASKET':
      return {
        ...state,
        failureFetching: false,
        isFetching: true,
      };
    case 'RECEIVE_TIP_MODERATION':
      state.tipsModeration.unshift(action.tipModeration);
      return {
        ...state,
        tipsModeration: state.tipsModeration,
      };
    case 'RECEIVE_TIPS_MODERATION':
      return {
        ...state,
        failureFetching: false,
        isFetching: false,
        isFetched: true,
        tipsModeration: action.tipsModeration,
      };
    case 'RECEIVE_TIPS_MODERATION_BASKET':
      return {
        ...state,
        failureFetching: false,
        isFetching: false,
        isFetched: true,
        tipsModerationBasket: action.tipsModerationBasket,
      };
    case 'RECEIVE_CURRENT_MODERATOR_DATA':
      return {
        ...state,
        currentModerator: action.currentModerator,
      };
    case 'APPROVE_TIPS_MODERATION':
      return {
        ...state,
        tipsModeration: (state.tipsModeration || []).filter(tip => tip.id !== action.mid),
        failureApproving: false,
        isApproving: true,
      };
    case 'ROLLBACK_APPROVE_TIPS_MODERATION':
      return {
        ...state,
        tipsModeration: action.tip
          ? [action.tip, ...(state.tipsModeration || []).filter(tip => tip.id !== action.tip.id)]
          : state.tipsModeration,
        isApproving: false,
        failureApproving: true,
      };
    case 'SYNC_MODERATION_APPROVED':
      return {
        ...state,
        tipsModeration: (state.tipsModeration || []).filter(
          tip => tip.id !== action.id && tip.payment_id !== action.paymentId,
        ),
      };
    case 'SYNC_MODERATION_REJECTED': {
      const rejected =
        (state.tipsModeration || []).find(
          tip => tip.id === action.id || tip.payment_id === action.paymentId,
        ) || null;
      const withoutRejected = (state.tipsModeration || []).filter(
        tip => tip.id !== action.id && tip.payment_id !== action.paymentId,
      );
      const basket = state.tipsModerationBasket || [];
      const alreadyInBasket = rejected ? basket.some(tip => tip.id === rejected.id) : false;

      return {
        ...state,
        tipsModeration: withoutRejected,
        tipsModerationBasket:
          rejected && !alreadyInBasket
            ? [
                ...basket,
                {
                  ...rejected,
                  rejected_at: action.rejectedAt || rejected.rejected_at || true,
                },
              ]
            : basket,
      };
    }
    case 'SYNC_MODERATION_RESTORED': {
      const restored =
        (state.tipsModerationBasket || []).find(
          tip => tip.id === action.id || tip.payment_id === action.paymentId,
        ) || null;
      const withoutRestored = (state.tipsModerationBasket || []).filter(
        tip => tip.id !== action.id && tip.payment_id !== action.paymentId,
      );
      const queue = state.tipsModeration || [];
      const alreadyInQueue = restored ? queue.some(tip => tip.id === restored.id) : false;

      return {
        ...state,
        tipsModerationBasket: withoutRestored,
        tipsModeration:
          restored && !alreadyInQueue ? [...queue, { ...restored, rejected_at: null }] : queue,
      };
    }
    case 'REJECT_TIPS_MODERATION': {
      const rejected = (state.tipsModeration || []).find(tip => tip.id === action.mid);
      return {
        ...state,
        tipsModerationBasket: rejected
          ? [...(state.tipsModerationBasket || []), rejected]
          : state.tipsModerationBasket,
        tipsModeration: (state.tipsModeration || []).filter(tip => tip.id !== action.mid),
        failureRejecting: false,
        isRejecting: true,
      };
    }
    case 'ROLLBACK_REJECT_TIPS_MODERATION':
      return {
        ...state,
        tipsModeration: action.tip
          ? [action.tip, ...(state.tipsModeration || []).filter(tip => tip.id !== action.tip.id)]
          : state.tipsModeration,
        tipsModerationBasket: action.tip
          ? (state.tipsModerationBasket || []).filter(tip => tip.id !== action.tip.id)
          : state.tipsModerationBasket,
        isRejecting: false,
        failureRejecting: true,
      };
    case 'RESTORE_TIPS_MODERATION': {
      const restored = (state.tipsModerationBasket || []).find(tip => tip.id === action.mid);
      return {
        ...state,
        tipsModeration: restored
          ? [...(state.tipsModeration || []), restored]
          : state.tipsModeration,
        tipsModerationBasket: (state.tipsModerationBasket || []).filter(
          tip => tip.id !== action.mid,
        ),
        failureRejecting: false,
        isRestoring: true,
      };
    }
    case 'ROLLBACK_RESTORE_TIPS_MODERATION':
      return {
        ...state,
        tipsModerationBasket: action.tip
          ? [
              action.tip,
              ...(state.tipsModerationBasket || []).filter(tip => tip.id !== action.tip.id),
            ]
          : state.tipsModerationBasket,
        tipsModeration: action.tip
          ? (state.tipsModeration || []).filter(tip => tip.id !== action.tip.id)
          : state.tipsModeration,
        isRestoring: false,
      };
    case 'FAILURE_TIPS_MODERATION':
      return {
        ...state,
        failureFetching: true,
        isFetching: false,
      };
    case 'FAILURE_TIPS_MODERATION_BASKET':
      return {
        ...state,
        failureFetching: true,
        isFetching: false,
      };
    case 'DISPLAY_MODERATION_BASKET_MODAL':
      return {
        ...state,
        forceModerationBasketModal: true,
      };
    case 'HIDE_MODERATION_BASKET_MODAL':
      return {
        ...state,
        forceModerationBasketModal: false,
      };
    default:
      return state;
  }
};
